export function stickyNav() {
    const header = $(".header");
    const headerHeight = header.innerHeight();
    const stickyArea = $(".sticky-area");
    const stickyNav = $('.aside-menu');
    const sections = $('.anchored-block');
    const topIndent = 50;
    let scrollTop;

    if ($(".article h2").length) {
        let num = 1;
        $(".article h2").each(function(index, el) {
            $(this).addClass('anchored-block');
            let anchor_id = 'heading-anchor'+ num++;
            let text = $(this).text();
            let navLink = "<li><a href='#" + anchor_id + "'>" + text + "</a></li>";
            $(this).attr('id', anchor_id);
            stickyNav.find('ul').append(navLink);
        });
    } else {
        stickyNav.remove();
    }

    stickyNav.find('a').on('click', function (e) {
        e.preventDefault();

        const target = $(this).attr("href").slice(1);

        if (target) {
            const anchoredBlock = $(`#${target}`);

            if (anchoredBlock.length) {
                $("html, body").animate({scrollTop: anchoredBlock.offset().top - headerHeight - topIndent / 2}, 500);
            }
        }
    })

    function sticky() {
        if (window.innerWidth > 1023) {
            scrollTop = $(window).scrollTop();
            const stickyAreaHeight = stickyArea.innerHeight();
            const stickyAreaTop = stickyArea.offset().top;
            const stickyAreaBottom = stickyAreaHeight + stickyAreaTop - headerHeight + topIndent;

            if (scrollTop > stickyAreaTop - headerHeight - topIndent && scrollTop < stickyAreaBottom - headerHeight) {
                stickyArea.addClass('has-fixed-child');
            } else if (scrollTop > stickyAreaBottom - headerHeight) {
                stickyArea.removeClass('has-fixed-child');
            } else {
                stickyNav.find('li').removeClass('active');
                stickyArea.removeClass('has-fixed-child');
            }


            if (stickyArea.hasClass('has-fixed-child')) {
                sections.each(function (index, section) {
                    const $this = $(section);
                    const itemOffsetTop = $this.offset().top;
                    const attr = $this.attr('id');
                    let sliderNavItem = stickyNav.find('a[href="#' + attr.toLowerCase() + '"]').parent();
                    if ((scrollTop + headerHeight + topIndent >= itemOffsetTop)) {
                        if (!sliderNavItem.hasClass('active')) {
                            sliderNavItem.siblings().removeClass('active');
                            sliderNavItem.addClass('active');
                            $this.addClass('active');
                        }
                    } else {
                        $this.removeClass('active');
                    }
                })
            }

        } else {
            stickyArea.removeClass('has-fixed-child');
        }
    }

    $(window).on("load scroll resize", function () {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyNav.js